var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor show-widget" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("User ID")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: { "automation-mode": "" },
              model: {
                value: _vm.clone.userId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "userId", $$v)
                },
                expression: "clone.userId",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("User Session ID")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: { "automation-mode": "" },
              model: {
                value: _vm.clone.sessionId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "sessionId", $$v)
                },
                expression: "clone.sessionId",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Title")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type Title",
                "show-attributes": true,
                "show-emoji": true,
                "max-character-count": 1024,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.title,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "title", $$v)
                },
                expression: "clone.title",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Mode")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              attrs: { "default-value": "url" },
              model: {
                value: _vm.clone.mode,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "mode", $$v)
                },
                expression: "clone.mode",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "url" } }, [
                _vm._v("URL"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "html" } }, [
                _vm._v("HTML"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.clone.mode === "url"
        ? _c("section", [
            _c("div", { staticClass: "title" }, [_vm._v("URL")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-editor-wrapper" },
              [
                _c("TiptapEditor", {
                  attrs: { "automation-mode": "" },
                  model: {
                    value: _vm.clone.url,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "url", $$v)
                    },
                    expression: "clone.url",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "html"
        ? _c("section", [
            _c("div", { staticClass: "title" }, [_vm._v("HTML Content")]),
            _vm._v(" "),
            _c("div", {
              staticClass: "monaco-html-editor-container",
              attrs: { id: "monaco-html-editor-container" },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Full Screen Mode")]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.fullScreen,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "fullScreen", $$v)
              },
              expression: "clone.fullScreen",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }